module.exports = __webpack_public_path__ + "static/media/spring-che-small-mobile.e75e4b00.png";